import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import EventsForm from "components/events/EventsForm";
import { useEvents } from "components/events/hooks/useEvents";
import Alert from "components/common/Alert";

export default function EditEvent() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { loadEventsById, editEvent } = useEvents();

  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(null);

  const userId = "69579c6190a653b640e65639";

  useEffect(() => {
    loadEventsById(id)
      .then((res) => setInitialData(res))
      .finally(() => setLoading(false));
      
  }, [id]);

  if (loading) return <p>Loading...</p>;

  return (
    <>
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}

      <EventsForm
        initialData={initialData}
        onSubmit={async (formData) => {
            try {
            formData.append("updated_by", userId);

            await editEvent(id, formData);

            navigate("/admin/events");
            } catch (error) {
            setAlert({
                type: "error",
                message:
                error.response?.data?.message ||
                "Failed to update event",
            });
            }
            }}
        onBack={() => navigate("/admin/events")}

        />

    </>
  );
}
